import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Campo, FormComponent } from '@components/form/form.component';
import { isMoment } from 'moment';

export interface Acao {
  label?: string;
  icon?: string;
  color?: string;
  tooltip: string;
  disabled?: boolean;
  hide?: boolean;
  action: () => void;
}

@Component({
  selector: 'app-filtros',
  templateUrl: './filtros.component.html',
  styleUrls: ['./filtros.component.scss'],
})
export class FiltrosComponent {
  @Input()
  filtros: Campo[] = [];

  @Input()
  esconderAcao: boolean = false;

  @Input()
  acoes: Acao[] = [];

  @Output()
  onSearch: EventEmitter<string> = new EventEmitter();

  @ViewChild(FormComponent) formComponent!: FormComponent;

  constructor() {}

  /**
   * Filtrar listagens com valores iniciais dos filtros
   */
  ngAfterViewInit() {
    if (this.formComponent) {
      this.onSubmit(this.formComponent.form);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['filtros']) {
      // this.form = this.montarFormulario();
    }
  }

  limparFiltros(form: FormComponent) {
    form.reset();
    this.onSearch.emit('');
  }

  /**
   * Transformar em uma query de pesquisa
   * Ex: filtro1=valor1&filtro2=valor2a,valor2b&filtro3=valor3%
   */
  onSubmit(form: FormGroup) {
    const query = Object.keys(form.value)
      .map((key: string) => {
        const value = form.value[key];

        if (!value) return null;

        if (Array.isArray(value)) {
          if (value.every(isMoment)) {
            const start =
              value[0].startOf('day').subtract(3, 'hours').format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
            const end =
              value[1].endOf('day').subtract(3, 'hours').format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';

            if (key.includes('||')) {
              return key
                .split('||')
                .map((k: string) => `${k.trim()}=${start}..${end}||`)
                .join('&');
            }

            return `${key}=${start}..${end}`;
          }

          return `${key}=${value.join(',')}`;
        }

        if (isMoment(value)) {
          return `${key}=${value.format('YYYY-MM-DD')}`;
        }

        if (key.includes('+')) {
          return key
            .split('+')
            .map((k: string) => `${k.trim()}=${value}`)
            .join('&');
        }

        if (key.includes('||')) {
          return key
            .split('||')
            .map((k: string) => `${k.trim()}=${value}||`)
            .join('&');
        }

        if (key.startsWith('%') && key.endsWith('%')) {
          return `${key.replaceAll('%', '')}=%${value}%`;
        }

        if (key.startsWith('%')) {
          return `${key.slice(1)}=%${value}`;
        }

        if (key.endsWith('%')) {
          return `${key.slice(0, -1)}=${value}%`;
        }

        return `${key}=${value}`;
      })
      .filter((value: string | null) => value)
      .join('&');

    if (this.onSearch) {
      this.onSearch.emit(query);
    }
  }
}
